import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { DateTime } from 'luxon';
import { ButtonBase } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Box, Interpunct } from 'components/common_v2/layouts';
import { BodyRegular, BodySmall } from 'components/common_v2/typography';
import Avatar from 'components/common_v2/userComponents/Avatar';
import { withNotification } from 'components/common_v2/notifications';
import { getDurationString } from '../helpers';

const MessageContent = ({
  message: {
    id, sender, body, createdAt, job
  },
  handleMessageClick
}) => {
  const theme = useTheme();

  return (
    <ButtonBase onClick={() => handleMessageClick(job.id)} sx={{ width: '100%' }} data-test-id="notifications__message-content">
      <Box
        key={`notification-${id}`}
        padding="16px"
        alignItems="center"
        style={{ borderBottom: `1px solid ${theme.palette.action.divider}`, width: '100%' }}
      >
        <Avatar
          style={{ marginRight: '12px' }}
          size="48px"
          avatarUrl={sender.avatarUrl}
          name="Test"
          id={id}
        />
        <div style={{ width: '100%' }}>
          <Box justifyContent="space-between">
            <BodyRegular className="bold">
              {sender.fullName}
            </BodyRegular>
            <BodySmall className="info">{getDurationString(createdAt)}</BodySmall>
          </Box>
          <Box alignItems="center">
            <BodySmall className="info">
              {get(job, 'jobRequest.requestName')}
            </BodySmall>
            <Interpunct />
            <BodySmall className="info">
              {DateTime.fromISO(get(job, 'jobRequest.startDate')).toLocaleString(DateTime.DATE_MED)}
            </BodySmall>
          </Box>
          <BodyRegular className="info" style={{ textAlign: 'left' }}>
            {body}
          </BodyRegular>
        </div>
      </Box>
    </ButtonBase>
  );
};

MessageContent.propTypes = {
  message: PropTypes.shape({
    id: PropTypes.string,
    sender: PropTypes.object,
    body: PropTypes.string,
    createdAt: PropTypes.string,
    job: PropTypes.object
  }).isRequired,
  handleMessageClick: PropTypes.func.isRequired
};

export const Message = withNotification((props) => <MessageContent {...props} />);
